// extracted by mini-css-extract-plugin
export default {"win10GridBox":"win10GridBox_IgF5G","mainBox":"mainBox_xGi6K"};